import { render, staticRenderFns } from "./AlertNotice.vue?vue&type=template&id=705ec86f&"
import script from "./AlertNotice.vue?vue&type=script&lang=js&"
export * from "./AlertNotice.vue?vue&type=script&lang=js&"
import style0 from "./AlertNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports